import { Component, inject } from '@angular/core';
import { NgbActiveModal, NgbModal, type NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { isFunction, isString } from 'lodash-es';
import { catchError, EMPTY, type ObservedValueOf, type OperatorFunction } from 'rxjs';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error.component.html',
  standalone: true,
  imports: []
})
export class ErrorComponent {
  readonly modal = inject(NgbActiveModal);
  title = '';
  body: string[] = [];
}

export function showError(modal: NgbModal, title: string, body: string[], options?: NgbModalOptions) {
  const em = modal.open(ErrorComponent, options);
  const i = em.componentInstance as ErrorComponent;
  i.title = title;
  i.body = body;
  return em.closed;
}

export function catchErrorModalOrEmpty<T>(modal: NgbModal, title: string, body: string[], then?: () => void): OperatorFunction<T, T | ObservedValueOf<never>> {
  return catchError((err: any) => {
    const fullbody = body.concat([ parseError(err) ]);
    return showError(modal, title, fullbody).pipe(() => {
      if (isFunction(then)) then();
      return EMPTY;
    });
  });
}

function parseError(err: any): string {
  if (isString(err['error']) && err.error.length > 0) return err.error;
  if (isString(err['message']) && err.message.length > 0) return err.message;
  return 'Nessun messaggio di errore disponibile';
}
